/* Enhancements for the editorial sections surrounding the existing collection. */
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    root.kimonoCollectionCleanup = () => controller.abort();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    root.querySelectorAll('.faq details').forEach((details) => {
      const summary = details.querySelector('summary');
      const answer = details.querySelector('p');
      let animation = null;
      let expanded = details.open;
      const finish = () => {
        details.open = expanded;
        animation?.cancel();
        animation = null;
        details.classList.remove('is-animating');
      };
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        // Start from the visible height so repeated clicks can reverse mid-animation.
        const startHeight = details.getBoundingClientRect().height;
        expanded = animation ? !expanded : !details.open;
        animation?.cancel();
        details.open = true;
        const borderHeight = details.offsetHeight - details.clientHeight;
        const endHeight = summary.getBoundingClientRect().height + borderHeight +
          (expanded ? answer.getBoundingClientRect().height : 0);
        if (reducedMotion.matches || typeof details.animate !== 'function') {
          finish();
          return;
        }
        details.classList.add('is-animating');
        const currentAnimation = details.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'both' });
        animation = currentAnimation;
        currentAnimation.onfinish = () => {
          if (animation === currentAnimation) finish();
        };
      }, { signal });
      signal.addEventListener('abort', finish, { once: true });
    });

  };
  document.querySelectorAll('[data-kimono-collection]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kimono-collection]').forEach(initialize);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-kimono-collection]').forEach((root) => root.kimonoCollectionCleanup?.());
  });
})();
